import React from "react";

const AboutSection = () => {
  return (
    <div className="container-fluid bg-light">
      <div className="container">
        <div className="row">

          {/* Left Box */}
          <div className="col-lg-5">
            <div className="d-flex flex-column align-items-center justify-content-center bg-primary h-100 py-5 px-3 text-white">
              
              <i className="flaticon-brickwall display-1 text-secondary mb-3"></i>
              
              <h4 className="display-3 mb-3">10+</h4>
              <h1 className="m-0">Years Experience</h1>

            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-7 m-0 my-lg-5 pt-5 pb-5 pb-lg-2 pl-lg-5">

            <h6 className="text-primary text-uppercase mb-3">
              About Us
            </h6>

            <h1 className="mb-4 section-title">
             Who We Are 
            </h1>

            <p>
              Your Trusted Partner in Construction & Interiors
            </p>

            {/* Features */}
            <div className="row py-2">

              <div className="col-sm-6">
                <div className="d-flex align-items-center mb-4">
                  <i className="flaticon-house text-primary mr-3"></i>
                  <h5 className="m-0">Project Planning</h5>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="d-flex align-items-center mb-4">
                  <i className="flaticon-stairs text-primary mr-3"></i>
                  <h5 className="m-0">Exterior & Interior</h5>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="d-flex align-items-center mb-4">
                  <i className="flaticon-office text-primary mr-3"></i>
                  <h5 className="m-0">Commercial Design</h5>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="d-flex align-items-center mb-4">
                  <i className="flaticon-living-room text-primary mr-3"></i>
                  <h5 className="m-0">Residential Design</h5>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutSection;